
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cartaderechosconsumidor",
      function () {
        return require("private-next-pages/cartaderechosconsumidor/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cartaderechosconsumidor"])
      });
    }
  